// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = "https://hlqszecqxbiotzhbhxar.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhscXN6ZWNxeGJpb3R6aGJoeGFyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTgxMTU0MjgsImV4cCI6MjA3MzY5MTQyOH0.AQ2UI1-Y-m86TKYVWsLPWCGeJlGB3IjPvdcoQVO39so";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
  }
});